import { Injectable } from '@angular/core';
import { BaseGridService } from 'ngx-mt-ui-lib/services/base-grid';
import { ECriteria } from 'ngx-mt-ui-lib/enums';
import { Filters, IGridSorting, ISelectItem } from 'ngx-mt-ui-lib/interfaces';
import { IUserGridItem } from '@core/interfaces/user';
export type TUserGridFilters = {
  phone: Filters.TFilterModel<'phone', string, string>;
  ipDeleted: Filters.TFilterModel<'ipDeleted', string, string>;
  ipActual: Filters.TFilterModel<'ipActual', string, string>;
  subsystemIds: Filters.TFilterModel<
    'subsystemIds',
    string,
    ISelectItem<unknown, string>[]
  >;
  isDeleted: Filters.TFilterModel<'isDeleted', boolean, boolean>;
  isAccessAdmin: Filters.TFilterModel<'isAccessAdmin', boolean, boolean>;
  authorized: Filters.TFilterModel<'authorized', boolean, boolean>;
  id: Filters.TFilterModel<'id', string, string>;
  fullName: Filters.TFilterModel<'fullName', string, string>;
  login: Filters.TFilterModel<'login', string, string>;
  email: Filters.TFilterModel<'email', string, string>;
  isBlocked: Filters.TFilterModel<'isBlocked', boolean, boolean>;
};
@Injectable()
export class UserGridService extends BaseGridService<
  IUserGridItem,
  TUserGridFilters
> {
  public readonly gridId = 'admin.users.keycloak';
  protected override readonly defaultFilters: TUserGridFilters = {
    phone: { field: 'phone', value: null, criteria: ECriteria.like },
    ipDeleted: { field: 'ipDeleted', value: null, criteria: ECriteria.like },
    ipActual: { field: 'ipActual', value: null, criteria: ECriteria.like },
    subsystemIds: {
      field: 'subsystemIds',
      value: null,
      criteria: ECriteria.in,
    },
    isDeleted: { field: 'isDeleted', value: null, criteria: ECriteria.equals },
    isAccessAdmin: {
      field: 'isAccessAdmin',
      value: null,
      criteria: ECriteria.equals,
    },
    authorized: {
      field: 'authorized',
      value: null,
      criteria: ECriteria.equals,
    },
    id: { field: 'id', value: null, criteria: ECriteria.equals },
    fullName: { field: 'fullName', value: null, criteria: ECriteria.like },
    login: { field: 'login', value: null, criteria: ECriteria.like },
    email: { field: 'email', value: null, criteria: ECriteria.like },
    isBlocked: { field: 'isBlocked', value: null, criteria: ECriteria.equals },
  };
  protected override readonly defaultSorting: IGridSorting[] = [
    { field: 'fullName', index: 0, direction: 'asc' },
  ];
  constructor() {
    super();
    this.init();
  }
}
